import { createContext } from 'react';
import { HubConnection } from '@microsoft/signalr';

interface NotificationContextType {
    notificationConnection: HubConnection;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export default NotificationContext;
